<template>
  <div> 
    <div class="panel panel-warning" style="margin-left: 10px;">
        <div class="panel-heading">
            <h3 class="panel-title"><span style="font-weight: bold;">Año</span></h3>
        </div>
        <div class="panel-body panel-body-vue" >            
            <ul class="carSizeContainer"    >        
                <li v-for='itemsDetail in ItemsDetails'>
                    <div>                                                
                        <router-link v-bind:to="'/view/0/year/' + itemsDetail.model_year" tag='a' > <span>{{itemsDetail.model_year}} <span >({{itemsDetail.model_year_count}})</span> </span></router-link>
                        <!--<a v-bind:href="'/view/0/year/' + itemsDetail.model_year"> <span >{{itemsDetail.model_year}} <span >({{itemsDetail.model_year_count}})</span> </span></a>-->
                    </div>
                </li>         
            </ul>
        </div>
    </div>                     
  </div>
</template>

<script>
export default {  
  data: function () {
    return {
      ItemsDetails: [],      
    }
  },
  created: function () {                  

  },
  mounted: function () {                            
    this.getItemsDetails();    
  },
  methods: {
    getItemsDetails: function() {              
        
        this.$http.get('api/getyearforsalecount').then(response => {   

            this.ItemsDetails = response.body.map(obj =>{                                                                             
                return obj;
            });                                    
                        
            this.gotData = true;                     
        }, response => {            
            //eventBus.$emit('errorMsg',response);
        });
    },      
    GoToUrl: function(id){        
        //this.$router.push('/view');        
    },    
  },
  filters: {

  },
  computed: {      
  }
}
</script>

<style scoped>
    .carSizeContainer {                   
        list-style: none;        
        margin-left: -35px;
        font-weight: 500;
        font-size: 16px;        
        padding-top: 10px;
    }

    li {
        padding-top: 3px;
    }
    .panel-body-vue {
        padding: 0px;
    }
</style>



// WEBPACK FOOTER //
// CarYearSideBar.vue?77559450